module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/iKkaYZ/tc-custom/9781608469185.jpg?1725723409287",
      "alt": "This image is the cover for the book Subterranean Fire"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Subterranean Fire\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“A concise, well-written history of U.S. working-class struggle and radicalism” from the author of "), _c('i', [_vm._v("Women and Socialism: Class, Race, and Capital")]), _vm._v(" ("), _c('i', [_vm._v("Solidarity")]), _vm._v(").")]), _c('br'), _c('br'), _vm._v("Smith explores how the connection between the U.S. labor movement and the Democratic Party, with its extensive corporate ties, has repeatedly held back working-class struggles. And she closely examines the role of the labor movement in the 2004 presidential election, tracing the shrinking electoral influence of organized labor and the failure of labor-management cooperation, “business unionism,” and reliance on the Democrats to deliver any real gains."), _c('br'), _c('br'), _c('b', [_vm._v("“Sharon Smith brings that history to life once again, blasting through the myths of the working class that Trump-era narratives cling to in order to connect us once again to the possibility of building broad solidarity.” —Sarah Jaffe, author of Work Won’t Love You Back")]), _c('br'), _c('br'), _c('b', [_vm._v("“A veteran worker-intellectual brilliantly addresses the crisis of the labor movement, skewering those who believe that renewal can come from the top down, and encouraging those who are fighting to rebuild it from the bottom up.” —Mike Davis, author of Planet of Slums")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sharon Smith\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Haymarket Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0